import { defineComponent } from 'navigation-components/platform/models';
import { DUMMY_COMPONENT } from '../constants';
export const dummyComponentDef = defineComponent(DUMMY_COMPONENT, {
  path: '',
  name: DUMMY_COMPONENT,
  capabilities: [],
  deferLoading: true,
  enableHubless: true
});